import { configureStore } from '@reduxjs/toolkit';

// Front
import Layout from './layouts/layoutSlice';

// Authentication
import Login from './auth/authSlice';

export const store = configureStore({
  reducer: {
    Layout,
    Login,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
